<template>
  <div class="fm-toolbar">
    <!-- Izquierda: toggle sidebar, atrás, home -->
    <div class="fm-toolbar-left">
      <button class="fm-btn-icon" @click="$emit('toggle-sidebar')" title="Menú lateral">
        <v-icon color="white" small>mdi-menu</v-icon>
      </button>
      <div class="fm-divider-v"></div>
      <button class="fm-btn-icon" :disabled="currentPath.length <= 1" @click="$emit('go-back')" title="Atrás">
        <v-icon color="white" small>mdi-chevron-left</v-icon>
      </button>
      <button class="fm-btn-icon" @click="$emit('go-home')" title="Inicio">
        <v-icon color="white" small>mdi-home</v-icon>
      </button>
    </div>


    <div class="fm-spacer" v-if="!isMobile"></div>
    <!-- Centro: búsqueda (solo desktop) -->
    <div class="fm-search-wrap">
      <v-icon class="fm-search-icon" color="#2D4B95" small>mdi-magnify</v-icon>
      <input
        class="fm-search"
        type="text"
        placeholder="Buscar archivos..."
        :value="searchValue"
        @input="onSearch"
      />
      <button v-if="searchValue" class="fm-search-clear" @click="clearSearch">
        <v-icon color="#2D4B95" small>mdi-close</v-icon>
      </button>
    </div>

    <!-- Derecha desktop: botones completos -->
    <div v-if="!isMobile" class="fm-toolbar-right">
      <div class="fm-divider"></div>
			
      <button class="fm-btn-primary" :disabled="!canUpload" @click="$emit('upload')">
        <v-icon small color="white">mdi-upload</v-icon>
        Subir Archivo
      </button>
      <button class="fm-btn-ghost" :disabled="!canCreateFolder" @click="$emit('create-folder')">
        <v-icon small color="white">mdi-folder-plus</v-icon>
        Nueva carpeta
      </button>

      <div class="fm-divider"></div>

      <!-- <div class="fm-view-toggle">
        <button :class="['fm-btn-icon', { active: viewMode === 'grid' }]" @click="$emit('set-view', 'grid')" title="Vista cuadrícula">
          <v-icon small color="white">mdi-view-grid</v-icon>
        </button>
        <button :class="['fm-btn-icon', { active: viewMode === 'list' }]" @click="$emit('set-view', 'list')" title="Vista lista">
          <v-icon small color="white">mdi-view-list</v-icon>
        </button>
      </div>

      <div class="fm-sort-menu">
        <button class="fm-btn-ghost fm-sort-btn" @click="sortOpen = !sortOpen">
          <v-icon small color="white">mdi-sort</v-icon>
          <span>Ordenar</span>
        </button>
        <div v-if="sortOpen" class="fm-dropdown" v-click-outside="() => sortOpen = false">
          <button v-for="opt in sortOptions" :key="opt.key"
            :class="['fm-dropdown-item', { active: sortBy === opt.key }]"
            @click="$emit('set-sort', opt.key); sortOpen = false">
            {{ opt.label }}
            <span v-if="sortBy === opt.key" class="fm-sort-arrow">{{ sortDir === 'asc' ? '↑' : '↓' }}</span>
          </button>
        </div>
      </div>

      <div class="fm-sort-menu">
        <button :class="['fm-btn-icon', { active: showDeleted }]" @click="emitAndClose('set-show-deleted', !showDeleted)" title="Vista lista">
          <span>Mostrar Eliminados</span>
        </button>
      </div> -->

			<div class="fm-action-menu">
				<button
					:class="['fm-btn-ghost', 'fm-menu-trigger', { active: menuOpen }]"
					@click="menuOpen = !menuOpen"
					title="Opciones"
				>
					<v-icon color="white" small>mdi-dots-vertical</v-icon>
					<span>Opciones</span>
				</button>

				<transition name="fm-menu">
					<div v-if="menuOpen" class="fm-menu-panel" v-click-outside="() => menuOpen = false">
						<!-- Vista -->
						<div class="fm-menu-section">
							<p class="fm-menu-label">Vista</p>
							<button
								:class="['fm-menu-item', { 'fm-menu-item--active': viewMode === 'grid' }]"
								@click="$emit('set-view', 'grid')"
							>
								<v-icon small :color="viewMode === 'grid' ? '#7eb3ff' : 'white'">mdi-view-grid</v-icon>
								<span>Cuadrícula</span>
								<v-icon v-if="viewMode === 'grid'" x-small color="#7eb3ff">mdi-check</v-icon>
							</button>
							<button
								:class="['fm-menu-item', { 'fm-menu-item--active': viewMode === 'list' }]"
								@click="$emit('set-view', 'list')"
							>
								<v-icon small :color="viewMode === 'list' ? '#7eb3ff' : 'white'">mdi-view-list</v-icon>
								<span>Lista</span>
								<v-icon v-if="viewMode === 'list'" x-small color="#7eb3ff">mdi-check</v-icon>
							</button>
						</div>

						<div class="fm-menu-divider"></div>

						<!-- Ordenar -->
						<div class="fm-menu-section">
							<p class="fm-menu-label">Ordenar por</p>
							<button
								v-for="opt in sortOptions"
								:key="opt.key"
								:class="['fm-menu-item', { 'fm-menu-item--active': sortBy === opt.key }]"
								@click="$emit('set-sort', opt.key)"
							>
								<v-icon small :color="sortBy === opt.key ? '#7eb3ff' : 'white'">{{ opt.icon }}</v-icon>
								<span>{{ opt.label }}</span>
								<span v-if="sortBy === opt.key" class="fm-sort-indicator">
									{{ sortDir === 'asc' ? '↑' : '↓' }}
								</span>
							</button>
						</div>

						<div class="fm-menu-divider"></div>

						<!-- Options -->
						<button
							:class="['fm-menu-item', { 'fm-menu-item--active': showDeleted }]"
							@click="emitAndClose('set-show-deleted', !showDeleted)"
						>
							<v-icon small :color="showDeleted ? '#7eb3ff' : 'white'">{{ showDeleted ? 'mdi-eye-off' : 'mdi-eye' }}</v-icon>
							<span>{{ showDeleted ? 'Ocultar' : 'Mostrar' }} Eliminados</span>
							<v-icon v-if="showDeleted" x-small color="#7eb3ff">mdi-check</v-icon>
						</button>

					</div>
				</transition>
			</div>

      <button class="fm-btn-icon" @click="$emit('reload')" title="Recargar">
        <v-icon small color="white">mdi-reload</v-icon>
      </button>
    </div>

    <!-- Derecha móvil: botón menú colapsado -->
    <div v-if="isMobile" class="fm-action-menu">
      <button
        :class="['fm-btn-icon', 'fm-menu-trigger', { active: menuOpen }]"
        @click="menuOpen = !menuOpen"
        title="Opciones"
      >
        <v-icon color="white" small>mdi-dots-vertical</v-icon>
      </button>

      <transition name="fm-menu">
        <div v-if="menuOpen" class="fm-menu-panel" v-click-outside="() => menuOpen = false">

          <!-- Acciones principales -->
          <div class="fm-menu-section">
            <button class="fm-menu-item fm-menu-item--accent" :disabled="!canUpload" @click="emitAndClose('upload')">
              <v-icon small color="white">mdi-upload</v-icon>
              <span>Subir archivo</span>
            </button>
            <button class="fm-menu-item" :disabled="!canCreateFolder" @click="emitAndClose('create-folder')">
              <v-icon small color="white">mdi-folder-plus</v-icon>
              <span>Nueva carpeta</span>
            </button>
          </div>

          <div class="fm-menu-divider"></div>

          <!-- Vista -->
          <div class="fm-menu-section">
            <p class="fm-menu-label">Vista</p>
            <button
              :class="['fm-menu-item', { 'fm-menu-item--active': viewMode === 'grid' }]"
              @click="$emit('set-view', 'grid')"
            >
              <v-icon small :color="viewMode === 'grid' ? '#7eb3ff' : 'white'">mdi-view-grid</v-icon>
              <span>Cuadrícula</span>
              <v-icon v-if="viewMode === 'grid'" x-small color="#7eb3ff">mdi-check</v-icon>
            </button>
            <button
              :class="['fm-menu-item', { 'fm-menu-item--active': viewMode === 'list' }]"
              @click="$emit('set-view', 'list')"
            >
              <v-icon small :color="viewMode === 'list' ? '#7eb3ff' : 'white'">mdi-view-list</v-icon>
              <span>Lista</span>
              <v-icon v-if="viewMode === 'list'" x-small color="#7eb3ff">mdi-check</v-icon>
            </button>
          </div>

          <div class="fm-menu-divider"></div>

          <!-- Ordenar -->
          <div class="fm-menu-section">
            <p class="fm-menu-label">Ordenar por</p>
            <button
              v-for="opt in sortOptions"
              :key="opt.key"
              :class="['fm-menu-item', { 'fm-menu-item--active': sortBy === opt.key }]"
              @click="$emit('set-sort', opt.key)"
            >
              <v-icon small :color="sortBy === opt.key ? '#7eb3ff' : 'white'">{{ opt.icon }}</v-icon>
              <span>{{ opt.label }}</span>
              <span v-if="sortBy === opt.key" class="fm-sort-indicator">
                {{ sortDir === 'asc' ? '↑' : '↓' }}
              </span>
            </button>
          </div>

          <div class="fm-menu-divider"></div>

          <!-- Options -->
					<button
						:class="['fm-menu-item', { 'fm-menu-item--active': showDeleted }]"
						@click="emitAndClose('set-show-deleted', !showDeleted)"
					>
						<v-icon small :color="showDeleted ? '#7eb3ff' : 'white'">{{ showDeleted ? 'mdi-eye-off' : 'mdi-eye' }}</v-icon>
						<span>{{ showDeleted ? 'Ocultar' : 'Mostrar' }} Eliminados</span>
						<v-icon v-if="showDeleted" x-small color="#7eb3ff">mdi-check</v-icon>
					</button>

          <div class="fm-menu-divider"></div>

          <!-- Recargar -->
          <div class="fm-menu-section">
            <button class="fm-menu-item" @click="emitAndClose('reload')">
              <v-icon small color="white">mdi-reload</v-icon>
              <span>Recargar</span>
            </button>
          </div>

        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { checkPermissions } from '@/helpers/permissions'

export default {
  name: 'FMToolbar',
  props: {
    currentPath: Array,
    viewMode: String,
    sortBy: String,
    sortDir: String,
		showDeleted: Boolean,
  },
  data() {
    return {
      searchValue: '',
      sortOpen: false,
      menuOpen: false,
      sortOptions: [
        { key: 'name',       label: 'Nombre',    icon: 'mdi-sort-alphabetical-ascending' },
        { key: 'updated_at', label: 'Modificado', icon: 'mdi-clock-outline' },
        { key: 'created_at', label: 'Creado',     icon: 'mdi-calendar-outline' },
        { key: 'size',       label: 'Tamaño',     icon: 'mdi-weight' },
        { key: 'ext',        label: 'Tipo',        icon: 'mdi-file-outline' },
      ],
    }
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.mobile
    },
    canUpload() {
      return checkPermissions(['create_files'])
    },
    canCreateFolder() {
      return checkPermissions(['create_folders'])
    },
  },
  directives: {
    clickOutside: {
      bind(el, binding) {
        el._clickOutside = (e) => { if (!el.contains(e.target)) binding.value(e) }
        document.addEventListener('click', el._clickOutside)
      },
      unbind(el) { document.removeEventListener('click', el._clickOutside) }
    }
  },
  watch: {
    isMobile(val) {
      // Cierra menús huérfanos al cambiar de breakpoint
      if (!val) this.menuOpen = false
      else this.sortOpen = false
    }
  },
  methods: {
    onSearch(e) {
      this.searchValue = e.target.value
      this.$emit('search', this.searchValue)
    },
    clearSearch() {
      this.searchValue = ''
      this.$emit('search', '')
      this.$nextTick(() => this.$refs.searchInput?.focus())
    },
    emitAndClose(event, payload) {
      this.$emit(event, payload)
      this.menuOpen = false
    },
  },
}
</script>

<style scoped>
/* ── Toolbar ── */
.fm-toolbar {
  height: var(--fm-toolbar-h);
  background: var(--fm-primary);
  box-shadow: 0 2px 8px rgba(45,75,149,0.18);
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 16px;
  flex-shrink: 0;
}

.fm-toolbar-left { display: flex; align-items: center; gap: 2px; }
.fm-toolbar-right { display: flex; align-items: center; gap: 6px; }
.fm-spacer { flex: 1; }

/* ── Botones base ── */
.fm-btn-icon {
  background: none;
  border: none;
  color: rgba(255,255,255,0.75);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding: 6px 8px;
  border-radius: var(--fm-radius-sm);
  font-family: var(--fm-font);
  font-size: 12px;
  font-weight: 500;
  transition: background 0.15s, color 0.15s;
}
.fm-btn-icon:hover  { background: rgba(255,255,255,0.12); color: #fff; }
.fm-btn-icon.active { background: rgba(255,255,255,0.20); color: #fff; }
.fm-btn-icon:disabled { opacity: 0.35; cursor: not-allowed; }

.fm-btn-primary {
  display: flex; align-items: center; gap: 6px;
  background: var(--fm-accent); color: #fff;
  border: none; border-radius: var(--fm-radius-sm);
  padding: 6px 14px; font-family: var(--fm-font);
  font-size: 13px; font-weight: 500; cursor: pointer;
  transition: opacity 0.15s, transform 0.1s;
  white-space: nowrap;
}
.fm-btn-primary:hover { opacity: 0.88; transform: translateY(-1px); }
.fm-btn-primary:disabled { opacity: 0.35; cursor: not-allowed; }

.fm-btn-ghost {
  display: flex; align-items: center; gap: 6px;
  background: rgba(255,255,255,0.10); color: rgba(255,255,255,0.85);
  border: 1px solid rgba(255,255,255,0.22); border-radius: var(--fm-radius-sm);
  padding: 6px 12px; font-family: var(--fm-font);
  font-size: 13px; font-weight: 500; cursor: pointer;
  transition: all 0.15s; white-space: nowrap;
}
.fm-btn-ghost:hover { background: rgba(255,255,255,0.18); color: #fff; border-color: rgba(255,255,255,0.35); }
.fm-btn-ghost:disabled { opacity: 0.35; cursor: not-allowed; }

/* ── Separadores ── */
.fm-divider-v { width: 1px; height: 20px; background: rgba(255,255,255,0.20); margin: 0 4px; }
.fm-divider   { width: 1px; height: 24px; background: rgba(255,255,255,0.18); margin: 0 4px; }

/* ── Search desktop ── */
.fm-search-wrap {
  flex: 1;
  position: relative;
  max-width: 400px;
  margin: 0 8px;
}
.fm-search-icon {
  position: absolute; left: 10px; top: 50%;
  transform: translateY(-50%); pointer-events: none;
}
.fm-search {
  width: 100%;
  background: var(--fm-surface2);
  border: 1px solid var(--fm-border);
  border-radius: 20px;
  padding: 6px 32px;
  color: var(--fm-text);
  font-family: var(--fm-font);
  font-size: 13px;
  outline: none;
  box-sizing: border-box;
  transition: border-color 0.2s, box-shadow 0.2s;
}
.fm-search:focus { border-color: var(--fm-accent); box-shadow: 0 0 0 3px var(--fm-accent-glow); }
.fm-search::placeholder { color: grey; }
.fm-search-clear {
  position: absolute; right: 8px; top: 50%;
  transform: translateY(-50%);
  background: none; border: none; cursor: pointer;
  display: flex; align-items: center; color: var(--fm-text2);
}

/* ── View toggle desktop ── */
.fm-view-toggle {
  display: flex;
  background: rgba(255,255,255,0.10);
  border: 1px solid rgba(255,255,255,0.20);
  border-radius: var(--fm-radius-sm);
  overflow: hidden;
}
.fm-view-toggle .fm-btn-icon { border-radius: 0; }

/* ── Sort dropdown desktop ── */
.fm-sort-menu { position: relative; }
.fm-dropdown {
  position: absolute; right: 0; top: calc(100% + 6px);
  background: var(--fm-surface2); border: 1px solid var(--fm-border2);
  border-radius: var(--fm-radius); padding: 6px;
  min-width: 150px; box-shadow: var(--fm-shadow); z-index: 200;
}
.fm-dropdown-item {
  display: flex; align-items: center; justify-content: space-between;
  width: 100%; background: none; border: none; color: var(--fm-text2);
  font-family: var(--fm-font); font-size: 13px; padding: 7px 10px;
  border-radius: var(--fm-radius-sm); cursor: pointer; transition: background 0.1s;
}
.fm-dropdown-item:hover { background: var(--fm-surface3); color: var(--fm-text); }
.fm-dropdown-item.active { color: var(--fm-primary); }
.fm-sort-arrow { font-size: 12px; }

/* ── Menú móvil ── */
.fm-action-menu { position: relative; }

.fm-menu-panel {
  position: absolute;
  right: 0;
  top: calc(100% + 8px);
  width: 240px;
  background: #1a2744;
  border: 1px solid rgba(255,255,255,0.10);
  border-radius: 10px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.45), 0 2px 8px rgba(0,0,0,0.25);
  z-index: 300;
  overflow: hidden;
  padding: 6px 0;
}

.fm-menu-section { padding: 4px 6px; }

.fm-menu-label {
  font-family: var(--fm-font);
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(255,255,255,0.35);
  margin: 0 0 2px 6px;
}

.fm-menu-divider { height: 1px; background: rgba(255,255,255,0.08); margin: 2px 0; }

.fm-menu-item {
  display: flex; align-items: center; gap: 10px;
  width: 100%; background: none; border: none;
  color: rgba(255,255,255,0.80);
  font-family: var(--fm-font); font-size: 13px;
  padding: 8px 10px; border-radius: 6px;
  cursor: pointer; text-align: left;
  transition: background 0.12s, color 0.12s;
}
.fm-menu-item span { flex: 1; }
.fm-menu-item:hover { background: rgba(255,255,255,0.08); color: #fff; }
.fm-menu-item:disabled { opacity: 0.35; cursor: not-allowed; }
.fm-menu-item--active { color: #7eb3ff; }
.fm-menu-item--active:hover { background: rgba(126,179,255,0.10); }
.fm-menu-item--accent { background: var(--fm-accent); color: #fff; font-weight: 500; }
.fm-menu-item--accent:hover { filter: brightness(1.1); }

.fm-sort-indicator { font-size: 12px; color: #7eb3ff; margin-left: auto; }

/* ── Search dentro del menú móvil ── */
.fm-menu-search-wrap { position: relative; margin: 2px 0; }
.fm-menu-search-icon {
  position: absolute; left: 9px; top: 50%;
  transform: translateY(-50%); pointer-events: none;
}
.fm-menu-search {
  width: 100%;
  background: rgba(255,255,255,0.07);
  border: 1px solid rgba(255,255,255,0.12);
  border-radius: 7px;
  padding: 7px 30px 7px 30px;
  color: #fff; font-family: var(--fm-font); font-size: 13px;
  outline: none; box-sizing: border-box;
  transition: border-color 0.2s, box-shadow 0.2s;
}
.fm-menu-search:focus {
  border-color: rgba(126,179,255,0.5);
  box-shadow: 0 0 0 3px rgba(126,179,255,0.12);
}
.fm-menu-search::placeholder { color: rgba(255,255,255,0.30); }
.fm-menu-search-clear {
  position: absolute; right: 7px; top: 50%;
  transform: translateY(-50%);
  background: none; border: none; cursor: pointer;
  display: flex; align-items: center;
  padding: 2px; opacity: 0.7;
}
.fm-menu-search-clear:hover { opacity: 1; }

/* ── Transición panel móvil ── */
.fm-menu-enter-active,
.fm-menu-leave-active { transition: opacity 0.15s ease, transform 0.15s ease; }
.fm-menu-enter,
.fm-menu-leave-to { opacity: 0; transform: translateY(-6px) scale(0.97); }
</style>